import { render, staticRenderFns } from "./DocFrente.vue?vue&type=template&id=35f37487&scoped=true&"
import script from "./DocFrente.vue?vue&type=script&lang=js&"
export * from "./DocFrente.vue?vue&type=script&lang=js&"
import style0 from "./DocFrente.vue?vue&type=style&index=0&id=35f37487&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f37487",
  null
  
)

export default component.exports